import { Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastServiceService {
  constructor(private messageService: MessageService, private ngZone: NgZone) {}

  showSuccess(summary: string, detail: string) {
    this.ngZone.run(() => {
      this.messageService.add({ severity: 'success', summary: summary, detail: detail, key: 'br', life: 10000 });
    });
  }

  showFail(summary: string, detail: string) {
    this.ngZone.run(() => {
      this.messageService.add({ severity: 'error', summary: summary, detail: detail, key: 'br', life: 10000 });
    });
  }

  showFailWithLife(summary: string, detail: string, life: number) {
    this.ngZone.run(() => {
      this.messageService.add({ severity: 'error', summary: summary, detail: detail, key: 'br', life: life });
    });
    console.error('showFail', summary, detail);
    this.messageService.add({ severity: 'error', summary: summary, detail: detail, key: 'br', life: 10000 });
  }
}
